import { Badge } from "@devhop/ui";
import type { EventFeaturesDTO } from "../../domain/contracts/event-features";
import { eventFeatureSummaryLabels } from "../lib/event-features-ui";

type EventFeatureChipsProps = {
  features: EventFeaturesDTO;
  className?: string;
  max?: number;
};

export function EventFeatureChips({
  features,
  className,
  max = 4,
}: EventFeatureChipsProps) {
  const labels = eventFeatureSummaryLabels(features);
  const visible = labels.slice(0, max);
  const rest = labels.length - visible.length;

  if (labels.length === 0) return null;

  return (
    <div className={`flex flex-wrap gap-1 ${className ?? ""}`}>
      {visible.map((label) => (
        <Badge key={label} variant="secondary" className="text-xs font-normal">
          {label}
        </Badge>
      ))}
      {rest > 0 ? (
        <Badge variant="outline" className="text-xs font-normal">
          +{rest}
        </Badge>
      ) : null}
    </div>
  );
}
